import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CutePlayer from '../components/CutePlayer';

const RenderView = () => {
  const location = useLocation();
  const [params, setParams] = useState({ stream: null, logo: null, name: null });

  useEffect(() => {
    const fullHash = window.location.hash;
    const queryIndex = fullHash.indexOf('?');
    let searchString = "";
    if (queryIndex !== -1) {
      searchString = fullHash.substring(queryIndex);
    } else {
      searchString = location.search;
    }

    const searchParams = new URLSearchParams(searchString);
    setParams({
      stream: searchParams.get('stream'),
      logo: searchParams.get('logo'),
      name: searchParams.get('name') || "Console Radio"
    });
  }, [location]);

  if (!params.stream) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center p-8 bg-white text-center">
        <div className="w-12 h-12 border-4 border-[#00AEEF] border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-[10px] font-black text-gray-400 uppercase tracking-[0.3em]">Initialising Player...</p>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4 bg-transparent overflow-hidden">
      <div className="w-full max-w-5xl">
        <CutePlayer 
          streamUrl={params.stream} 
          logoUrl={params.logo} 
          stationName={params.name} 
          shareUrl={window.location.href} // Allow sharing the standalone player itself
        />
      </div>
    </div>
  );
};

export default RenderView;